import React, {Component} from 'react';
import faq11 from "../../../../../../assets/img/faq11.png";
import {Link} from "react-router-dom";
import '../FaqPages/DeliveryTime.css'
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'
class DeliveryTimeTopics extends React.Component {
    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    };

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3 className="inline-block-element"><b>納期について</b></h3>

                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/deliverytime'>
                            <h4><b className="reduce-font-size cart-row-text-color"> お届け日を指定することはできますか？</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("b")}>
                        <Link to='/deliverytime'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 本日中に受付日を確定したいのですが、どうしたらよいですか？</b>
                            </h4>

                        </Link>

                    </div>

                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("c")}>
                        <Link to='/deliverytime'>
                            <h4><b className="reduce-font-size cart-row-text-color"> 商品はどれくらいで届きますか？</b>
                            </h4>
                        </Link>

                    </div>

                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>

        );
    }
}

export default DeliveryTimeTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/DeliveryTimeTopics.js